import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const OverviewAccountSkeleton = () => {
    const divs = Array.from({ length: 5 }, (_, index) => (
        <div className="my-2" key={index}>
            <Skeleton variant="rectangular" width={200} height={25}/>
        </div>
    ));
    return (

        <div className="col-lg-5 col-md-12 col-sm-12 mt-5 mb-3">
            <Skeleton variant="rectangular" width={250} height={35}/>
            <div className="mb-4">
                {divs}
            </div>
        </div>
    );
};

export default OverviewAccountSkeleton;